import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { ToastModule } from 'primeng/toast';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoadingUIComponent } from './components/loading-ui/loading-ui.component';
import { AuthenticationService } from './services/authentication.service';
import { Constants } from './helpers/constants';
import { WebSocketService } from './services/webSocket.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    LoginComponent,
    SidebarComponent,
    HeaderComponent,
    RouterOutlet,
    ToastModule,
    LoadingUIComponent,
    TranslateModule
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  isLoggedIn = signal<boolean>(false);
  isSidebarCollapsed = signal<boolean>(false);
  isMobileMenuOpen = signal<boolean>(false);

  constructor(public translate: TranslateService, private auth: AuthenticationService, private router: Router, private webSocket: WebSocketService) {
    translate.addLangs(['ko', 'en', 'vi']);
    translate.setDefaultLang('ko');

    const savedLang = localStorage.getItem(Constants.Language);
    const browserLang = translate.getBrowserLang();

    const langToUse = savedLang || (browserLang?.match(/ko|en|vi/) ? browserLang : 'ko');

    translate.use(langToUse);
  }

  ngOnInit() {
    this.webSocket.initWebSocket();
  }

  onLoginSuccess() {
    this.isLoggedIn.set(true);
  }

  onLogout() {
    this.auth.logout();
    this.isLoggedIn.set(false);
    this.isMobileMenuOpen.set(false);
    this.router.navigate(['/dashboard']);
  }

  toggleDesktopSidebar() {
    this.isSidebarCollapsed.update(state => !state);
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen.update(state => !state);
  }
}